import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Input,
  Label,
} from "reactstrap";
import classnames from "classnames";
import {
  IoCheckmarkDoneSharp,
  IoPlaySharp,
  IoPauseSharp,
  IoStopSharp,
  IoRefreshCircleOutline,
} from "react-icons/io5";
import SweetAlert from "react-bootstrap-sweetalert";
import Swal from "sweetalert2";
import { validarCedulaRepresentanteEscombros, validarUNRCompleto, validarURCompleto, validarCamposCondicionales, validarRecipientesCompleto, validarPorTipoOrden, validarActaTieneDatos } from './actaValidations';
//Import Breadcrumb
import Loader from "../../components/Common/Loader";
import { getCasosRead, postCasosStatusChange, getAgent, patchCasosUpdate, postFinalizarCaso, getUserList, postTransferirCasoPatinador, postReabrirCasos } from "../../helpers/backend";
import { generateActaVisitaPDFBlob, generateActaVisitaPDFBlobWithoutImages, generateActaAdicionalIndividualPDFBlob } from '../../components/ActaVisitaPDF';
import { useParams, useHistory } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ButtonVolver from "../../components/ButtonVolver";
import { useSelector } from "react-redux";
import CatastroEnel from './CatastroEnel';
import CatastroCiudadLimpia from './CatastroCiudadLimpia';
import GestionesCaso from './GestionesCaso';
import DatosFacturacion from './DatosFacturacion';
import DetallesOT from './DetallesOT';
import CasosCensoModal from "../../components/CasosCensoModal";
import './Casos.css'

const CasosDetails = (props) => {
  const id = useParams().id;
  const theme = useSelector((state) => state.theme.theme) || "light";
  const history = useHistory();
  const URL = process.env.REACT_APP_API_URL;
  const url = URL.split("/api");
  const URL1 = process.env.REACT_APP_API_URL.split("/api").join("");
  const [activeTab, setActiveTab] = useState("1");
  const [imagenSeleccionada, setImagenSeleccionada] = useState(null);

  // Estados para funcionalidad de acciones
  const [actionAlert, setActionAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  const [action, setAction] = useState("");
  const [ticket, setTicket] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [coordenadas, setCoordenadas] = useState("");
  const [ticketId, setTicketId] = useState(null);
  const [showCensoModal, setShowCensoModal] = useState(false);
  const [agent, setAgent] = useState({});
  const user = JSON.parse(localStorage.getItem("user"));
  const canReopenCase = user && (user.roles === "Administrador" || user.roles === "SuperAdmin");

  const handleReabrirCaso = async () => {
    const result = await Swal.fire({
      title: "Reabrir OT",
      text: "¿Desea reabrir este caso?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, reabrir",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#6c757d",
    });
    if (result.isConfirmed) {
      try {
        await postReabrirCasos(id);
        Swal.fire({
          title: "Éxito",
          text: "Caso reabierto correctamente",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
        getCasoData();
      } catch (error) {
        console.error("Error al reabrir el caso:", error);
        Swal.fire({
          title: "Error",
          text: "No se pudo reabrir el caso",
          icon: "error",
        });
      }
    }
  };

  // Estados para transferir a patinador
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [patinadores, setPatinadores] = useState([]);
  const [selectedPatinador, setSelectedPatinador] = useState("");
  const [loadingPatinadores, setLoadingPatinadores] = useState(false);
  const [transferring, setTransferring] = useState(false);

  // Estados para subida de imágenes
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);

  const [caso, setCaso] = useState({});
  const isFinalizado = caso?.estado === "FINALIZADO";
  const getCasoData = async () => {
    const response = await getCasosRead(id);
    const data = response.data;
    console.log('Datos del caso recibidos:', data);
    console.log('Imágenes del caso:', data.images);

    // Debug específico para firmas
    if (data.informe && data.informe.length > 0) {
      console.log('CasosDetails - Informe encontrado:', data.informe[0]);
      console.log('CasosDetails - Firmas en informe:', {
        representante_firma: data.informe[0].representante_firma,
        ciudad_limpia_firma: data.informe[0].ciudad_limpia_firma
      });
    } else {
      console.log('CasosDetails - No se encontró informe en el caso');
    }

    setCaso(data);
  };

  const getAgentData = async () => {
    const response = await getAgent();
    const data = response.data;
    setAgent(data);
  };

  // Función para obtener lista de patinadores
  const getPatinadores = async () => {
    setLoadingPatinadores(true);
    try {
      const response = await getUserList();
      const usuarios = response.data.results || [];
      // Filtrar solo los usuarios con contactType "PATINADOR"
      const patinadoresFiltrados = usuarios.filter(user =>
        user.contactType === "PATINADOR"
      );
      setPatinadores(patinadoresFiltrados);
    } catch (error) {
      console.error("Error al obtener patinadores:", error);
      Swal.fire({
        title: "Error",
        text: "No se pudieron cargar los patinadores",
        icon: "error"
      });
    } finally {
      setLoadingPatinadores(false);
    }
  };


  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const abrirImagenEnNuevaPestana = (imagenUrl) => {
    window.open(imagenUrl, "_blank");
  };

  // Función para manejar acciones del caso
  const handleAction = async (action, ticket, id) => {
    // 1. Loading Inmediato
    Swal.fire({
      title: 'Validando...',
      text: 'Verificando permisos y ubicación...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    // 2. Validación Geolocalización
    if (!navigator.geolocation) {
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'La geolocalización no está soportada por este navegador.'
      });
      return;
    }

    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
      const { latitude, longitude } = position.coords;
      setCoordenadas(latitude + " " + longitude);

      // Cerrar loading y abrir confirmación
      Swal.close();

      setAction(action);
      setTicket(ticket);
      setTicketId(id);
      setActionAlert(true); // Abre el SweetAlert de confirmación

    } catch (error) {
      console.error("Error obteniendo ubicación:", error);
      Swal.close();
      Swal.fire({
        icon: 'warning',
        title: 'Ubicación Requerida',
        text: 'Para continuar, es OBLIGATORIO autorizar el acceso a su ubicación. Por favor, habilite los permisos y vuelva a intentarlo.',
        confirmButtonColor: "#28a745",
      });
    }
  };

  const handleFinalizar = async (ticket, id) => {
    setTicket(ticket);
    setTicketId(id);

    // 1. Loading Inmediato
    Swal.fire({
      title: 'Validando...',
      text: 'Verificando permisos y ubicación...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    // Obtener ubicación obligatoria antes de cualquier modal
    let currentCoords = "";
    if (!navigator.geolocation) {
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'La geolocalización no está soportada por este navegador.'
      });
      return;
    }

    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
      currentCoords = position.coords.latitude + " " + position.coords.longitude;
      setCoordenadas(currentCoords);

      // Cerrar loading una vez obtenida la ubicación
      Swal.close();

    } catch (error) {
      console.error("Error obteniendo ubicación:", error);
      Swal.close();
      Swal.fire({
        icon: 'warning',
        title: 'Ubicación Requerida',
        text: 'Para finalizar el caso, es OBLIGATORIO autorizar el acceso a su ubicación. Por favor, habilite los permisos y vuelva a intentarlo.',
        confirmButtonColor: "#28a745",
      });
      return;
    }

    // Primer modal: Elegir si enviar informe o no
    const { value: choice } = await Swal.fire({
      title: "Finalizar OT",
      text: "¿Cómo desea finalizar la orden de trabajo?",
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: "Enviar informe al cliente",
      denyButtonText: "Finalizar sin enviar informe",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#28a745",
      denyButtonColor: "#ffc107",
      cancelButtonColor: "#6c757d",
      icon: "question"
    });

    if (!choice && choice !== false) {
      // Usuario canceló
      return;
    }

    let confirmed;

    if (choice === true) {
      // Usuario eligió enviar informe, mostrar modal con teléfono
      const defaultPhone = caso.informe && caso.informe.representante_telefono_celular
        ? caso.informe.representante_telefono_celular
        : '';

      const div = document.createElement('div');
      div.innerHTML = `
        <div style="text-align: left; margin-bottom: 15px;">
          <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #495057;">
            Número de teléfono del cliente:
          </label>
          <div id="phone-input-container" style="text-align: left;"></div>
        </div>
      `;

      let phoneValue = '';

      const phoneResult = await Swal.fire({
        title: "Enviar informe al cliente",
        html: div.innerHTML,
        showCancelButton: true,
        confirmButtonText: "Enviar informe",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
        didOpen: () => {
          const container = document.getElementById('phone-input-container');
          if (container) {
            container.innerHTML = `
              <div style="display: flex; border: 1px solid #ced4da; border-radius: 4px; overflow: hidden;">
                <select 
                  id="country-select" 
                  style="padding: 8px; border: none; background: #f8f9fa; border-right: 1px solid #ced4da; outline: none;"
                >
                  <option value="+57">🇨🇴 +57</option>
                  <option value="+1">🇺🇸 +1</option>
                  <option value="+52">🇲🇽 +52</option>
                  <option value="+34">🇪🇸 +34</option>
                  <option value="+54">🇦🇷 +54</option>
                  <option value="+56">🇨🇱 +56</option>
                  <option value="+51">🇵🇪 +51</option>
                  <option value="+58">🇻🇪 +58</option>
                  <option value="+593">🇪🇨 +593</option>
                  <option value="+591">🇧🇴 +591</option>
                </select>
                <input 
                  id="phone-input" 
                  type="tel" 
                  placeholder="300 123 4567"
                  value="${defaultPhone}"
                  style="flex: 1; padding: 8px 12px; border: none; outline: none; font-size: 14px;"
                />
              </div>
            `;

            const countrySelect = document.getElementById('country-select');
            const phoneInput = document.getElementById('phone-input');

            const formatPhoneNumber = (value) => {
              const numbers = value.replace(/\D/g, '');
              if (numbers.length <= 3) return numbers;
              if (numbers.length <= 6) return numbers.slice(0, 3) + ' ' + numbers.slice(3);
              return numbers.slice(0, 3) + ' ' + numbers.slice(3, 6) + ' ' + numbers.slice(6, 10);
            };

            if (defaultPhone) {
              const formatted = formatPhoneNumber(defaultPhone);
              phoneInput.value = formatted;
              phoneValue = '+57' + defaultPhone.replace(/\s/g, '');
            } else {
              phoneValue = '+57';
            }

            phoneInput.addEventListener('input', (e) => {
              const formatted = formatPhoneNumber(e.target.value);
              e.target.value = formatted;
              phoneValue = countrySelect.value + e.target.value.replace(/\s/g, '');
            });

            countrySelect.addEventListener('change', (e) => {
              phoneValue = e.target.value + phoneInput.value.replace(/\s/g, '');
            });

            phoneInput.focus();
          }
        },
        preConfirm: () => {
          if (!phoneValue || phoneValue.trim() === '+57' || phoneValue.trim() === '') {
            Swal.showValidationMessage('El número de teléfono es obligatorio');
            return false;
          }

          const numbersOnly = phoneValue.replace(/\D/g, '');

          if (numbersOnly.length < 10 || numbersOnly.length > 15) {
            Swal.showValidationMessage('Ingrese un número de teléfono válido (10-15 dígitos)');
            return false;
          }

          return { phone: numbersOnly, withReport: true };
        }
      });

      if (!phoneResult.value) {
        // Usuario canceló el modal de teléfono
        return;
      }

      confirmed = phoneResult.value;
    } else {
      // Usuario eligió finalizar sin enviar informe
      confirmed = { phone: '', withReport: false };
    }

    if (confirmed) {
      // Ejecutar validaciones del/las acta(s) antes de finalizar
      const informesToValidate = [];
      if (caso?.informe) informesToValidate.push(caso.informe);
      if (caso?.informes_adicionales && Array.isArray(caso.informes_adicionales)) informesToValidate.push(...caso.informes_adicionales);

      for (const acta of informesToValidate) {
        if (!validarActaTieneDatos(acta)) return;
        if (!validarCedulaRepresentanteEscombros(acta, caso)) return;
        if (!validarURCompleto(acta)) return;
        if (!validarUNRCompleto(acta)) return;
        if (!validarCamposCondicionales(acta)) return;
        if (!validarPorTipoOrden(acta, caso)) return;
        if (!validarRecipientesCompleto(acta)) return;
      }

      try {
        // Preparar FormData para envío
        const formData = new FormData();
        // Agregar coordenadas obligatoriamente
        formData.append('coordenadas', currentCoords);

        if (confirmed.withReport) {
          // Solo agregar teléfono y PDF si se va a enviar informe
          formData.append('phone', confirmed.phone);

          // Generar y adjuntar PDF
          // Obtener datos del informe para generar PDF
          const informe = caso.informe || {};

          // Preparar datos para el PDF
          const actaData = {
            // Información básica
            fecha_visita: informe.fecha_visita || new Date().toISOString().split('T')[0],
            hora_visita: informe.hora_visita || new Date().toTimeString().slice(0, 5),
            ciudad_visita: informe.ciudad_visita || 'Bogotá',
            dia_visita: informe.dia_visita || new Date().getDate().toString(),
            mes_visita: informe.mes_visita || new Date().toLocaleDateString('es-ES', { month: 'long' }),
            año_visita: informe.año_visita || new Date().getFullYear().toString(),
            archivo_no: informe.archivo_no || '',
            no_pqrs: informe.no_de_pqrs || caso.numero_reclamo || '',
            cuenta_suscriptor: informe.cuenta_suscriptor || '',
            cuenta_energia: informe.cuenta_energia || '',
            direccion: informe.direccion || caso.cliente?.[0].address?.[0].address || '',
            nombre_cliente: informe.nombre_cliente || caso.cliente?.[0]?.full_name || '',
            direccion_informe: informe.direccion_informe || '',

            // Datos del predio
            direccion_predio: informe.direccion_predio || '',
            estrato_predio: informe.estrato_predio || '',
            localidad_predio: informe.localidad_predio || '',
            actualizacion_nombre_suscriptor: informe.actualizacion_nombre_suscriptor || '',

            // Tablas dinámicas
            unidades_residenciales_detalle: informe.unidades_residenciales_detalle ?
              (typeof informe.unidades_residenciales_detalle === 'string' ?
                JSON.parse(informe.unidades_residenciales_detalle) :
                informe.unidades_residenciales_detalle) : [],
            producto_nombre: informe.producto_nombre || '',
            producto_detalle: informe.producto_detalle ?
              (typeof informe.producto_detalle === 'string' ?
                JSON.parse(informe.producto_detalle) :
                informe.producto_detalle) : [],
            unidades_no_residenciales_detalle: informe.unidades_no_residenciales_detalle ?
              (typeof informe.unidades_no_residenciales_detalle === 'string' ?
                JSON.parse(informe.unidades_no_residenciales_detalle) :
                informe.unidades_no_residenciales_detalle) : [],
            producto_unr: informe.producto_unr || '',
            recipientes_detalle: informe.recipientes_detalle ?
              (typeof informe.recipientes_detalle === 'string' ?
                JSON.parse(informe.recipientes_detalle) :
                informe.recipientes_detalle) : [],

            // Características del predio
            abandonado: informe.abandonado || false,
            suscriptor_inactivo: informe.suscriptor_inactivo || false,
            demolido: informe.demolido || false,
            en_construccion: informe.en_construccion || false,
            en_remodelacion: informe.en_remodelacion || false,
            inexistente: informe.inexistente || false,
            inhabitable_o_en_ruinas: informe.inhabitable_o_en_ruinas || false,
            lote: informe.lote || false,
            minimas_condiciones: informe.minimas_condiciones || false,
            programa_del_icbf: informe.programa_del_icbf || false,
            descuento_puerta_a_puerta: informe.descuento_puerta_a_puerta || false,
            se_cierra_pqr_como_no_atendido: informe.se_cierra_pqr_como_no_atendido || false,
            areas_comunes: informe.areas_comunes || false,
            predio_que_se_observa_vacio: informe.predio_que_se_observa_vacio || false,
            predio_se_observa_ocupado: informe.predio_se_observa_ocupado || false,
            cuenta_suscriptor_activo: informe.cuenta_suscriptor_activo || false,
            causa_demolicion: informe.causa_demolicion || "",
            suscriptor_activo_detalles: informe.suscriptor_activo_detalles || "",

            // Tipos de residuos
            tipos_residuos: {
              escombros: informe.escombros || false,
              especiales: informe.especiales || false,
              para_reuso: informe.para_relleno || false,
              para_escombrera: informe.para_escombrera || false,
              enlonado: informe.enlonado || false,
              a_granel: informe.a_granel || false
            },
            tipo_recoleccion: informe.tipo_recoleccion || '',
            valor_m3: informe.valor_m3 || '',
            m3_gratis: informe.m3_gratis || false,
            dos_m3_gratis: (informe.dos_m3_gratis ?? informe['2m3_gratis']) || false,
            cancelado: informe.cancelado || false,

            // Observaciones y representantes
            observaciones: informe.observaciones || '',
            representante_nombre: informe.representante_nombre || '',
            representante_cedula: informe.representante_cedula || '',
            representante_firma: informe.representante_firma,
            representante_telefono_celular: informe.representante_telefono_celular || '',
            ciudad_limpia_nombre: caso.contacto?.[0]?.full_name || caso.agente?.full_name || '',
            ciudad_limpia_codigo: informe.ciudad_limpia_codigo || caso.contacto?.[0]?.codigo_visitador || caso.agente?.codigo_visitador || '',
            ciudad_limpia_firma: informe.ciudad_limpia_firma,
            ciudad_limpia_telefono: informe.ciudad_limpia_telefono || '',
            anotaciones: informe.anotaciones || '',
            sin_firma: informe.sin_firma || false,
          };

          // Generar PDF como blob SIN imágenes para envío por WhatsApp
          const pdfResult = await generateActaVisitaPDFBlobWithoutImages(actaData, caso, caso.informes_adicionales || []);

          if (pdfResult.success) {
            // Crear archivo con nombre específico
            const fileName = `Acta_Visita_${caso.numero_reclamo || 'documento'}_${new Date().toISOString().split('T')[0]}.pdf`;
            const pdfFile = new File([pdfResult.blob], fileName, { type: 'application/pdf' });
            formData.append('pdf_file', pdfFile);
            // Generar PDF adicional CON imágenes (evidencias) y adjuntarlo
            const evidenciasResult = await generateActaVisitaPDFBlob(actaData, caso, caso.informes_adicionales || []);
            if (evidenciasResult.success) {
              const evidenciasFileName = `Acta_Visita_Evidencias_${caso.numero_reclamo || 'documento'}_${new Date().toISOString().split('T')[0]}.pdf`;
              const evidenciasFile = new File([evidenciasResult.blob], evidenciasFileName, { type: 'application/pdf' });
              formData.append('informe_pdf_evidencias', evidenciasFile);
            } else {
              console.error('Error generando PDF con evidencias:', evidenciasResult.error);
            }
          } else {
            throw new Error('Error generando PDF: ' + pdfResult.error);
          }
        } else {
          // Si no se envía informe, phone vacío pero sí generar PDF
          formData.append('phone', '');

          // Generar y adjuntar PDF aunque no se envíe por WhatsApp
          // Obtener datos del informe para generar PDF
          const informe = caso.informe || {};

          // Preparar datos para el PDF
          const actaData = {
            // Información básica
            fecha_visita: informe.fecha_visita || new Date().toISOString().split('T')[0],
            hora_visita: informe.hora_visita || new Date().toTimeString().slice(0, 5),
            ciudad_visita: informe.ciudad_visita || 'Bogotá',
            dia_visita: informe.dia_visita || new Date().getDate().toString(),
            mes_visita: informe.mes_visita || new Date().toLocaleDateString('es-ES', { month: 'long' }),
            año_visita: informe.año_visita || new Date().getFullYear().toString(),
            archivo_no: informe.archivo_no || '',
            no_pqrs: informe.no_de_pqrs || caso.numero_reclamo || '',
            cuenta_suscriptor: informe.cuenta_suscriptor || '',
            cuenta_energia: informe.cuenta_energia || '',
            direccion: informe.direccion || caso.cliente?.[0].address?.[0].address || '',
            nombre_cliente: informe.nombre_cliente || caso.cliente?.[0]?.full_name || '',
            direccion_informe: informe.direccion_informe || '',

            // Datos del predio
            direccion_predio: informe.direccion_predio || '',
            estrato_predio: informe.estrato_predio || '',
            localidad_predio: informe.localidad_predio || '',
            actualizacion_nombre_suscriptor: informe.actualizacion_nombre_suscriptor || '',

            // Tablas dinámicas
            unidades_residenciales_detalle: informe.unidades_residenciales_detalle ?
              (typeof informe.unidades_residenciales_detalle === 'string' ?
                JSON.parse(informe.unidades_residenciales_detalle) :
                informe.unidades_residenciales_detalle) : [],
            producto_nombre: informe.producto_nombre || '',
            producto_detalle: informe.producto_detalle ?
              (typeof informe.producto_detalle === 'string' ?
                JSON.parse(informe.producto_detalle) :
                informe.producto_detalle) : [],
            unidades_no_residenciales_detalle: informe.unidades_no_residenciales_detalle ?
              (typeof informe.unidades_no_residenciales_detalle === 'string' ?
                JSON.parse(informe.unidades_no_residenciales_detalle) :
                informe.unidades_no_residenciales_detalle) : [],
            producto_unr: informe.producto_unr || '',
            recipientes_detalle: informe.recipientes_detalle ?
              (typeof informe.recipientes_detalle === 'string' ?
                JSON.parse(informe.recipientes_detalle) :
                informe.recipientes_detalle) : [],

            // Características del predio
            abandonado: informe.abandonado || false,
            suscriptor_inactivo: informe.suscriptor_inactivo || false,
            demolido: informe.demolido || false,
            en_construccion: informe.en_construccion || false,
            en_remodelacion: informe.en_remodelacion || false,
            inexistente: informe.inexistente || false,
            inhabitable_o_en_ruinas: informe.inhabitable_o_en_ruinas || false,
            lote: informe.lote || false,
            minimas_condiciones: informe.minimas_condiciones || false,
            programa_del_icbf: informe.programa_del_icbf || false,
            descuento_puerta_a_puerta: informe.descuento_puerta_a_puerta || false,
            se_cierra_pqr_como_no_atendido: informe.se_cierra_pqr_como_no_atendido || false,
            areas_comunes: informe.areas_comunes || false,
            predio_que_se_observa_vacio: informe.predio_que_se_observa_vacio || false,
            predio_se_observa_ocupado: informe.predio_se_observa_ocupado || false,
            cuenta_suscriptor_activo: informe.cuenta_suscriptor_activo || false,
            causa_demolicion: informe.causa_demolicion || "",
            suscriptor_activo_detalles: informe.suscriptor_activo_detalles || "",

            // Tipos de residuos
            tipos_residuos: {
              escombros: informe.escombros || false,
              especiales: informe.especiales || false,
              para_reuso: informe.para_relleno || false,
              para_escombrera: informe.para_escombrera || false,
              enlonado: informe.enlonado || false,
              a_granel: informe.a_granel || false
            },
            tipo_recoleccion: informe.tipo_recoleccion || '',
            valor_m3: informe.valor_m3 || '',
            m3_gratis: informe.m3_gratis || false,
            dos_m3_gratis: (informe.dos_m3_gratis ?? informe['2m3_gratis']) || false,
            cancelado: informe.cancelado || false,

            // Observaciones y representantes
            observaciones: informe.observaciones || '',
            representante_nombre: informe.representante_nombre || caso.cliente?.[0]?.full_name || '',
            representante_cedula: informe.representante_cedula || caso.cliente?.[0]?.documentNumber || '',
            representante_firma: informe.representante_firma,
            representante_telefono_celular: informe.representante_telefono_celular || '',
            ciudad_limpia_nombre: caso.contacto?.[0]?.full_name || caso.agente?.full_name || '',
            ciudad_limpia_codigo: informe.ciudad_limpia_codigo || caso.contacto?.[0]?.codigo_visitador || caso.agente?.codigo_visitador || '',
            ciudad_limpia_firma: informe.ciudad_limpia_firma,
            ciudad_limpia_telefono: informe.ciudad_limpia_telefono || '',
            anotaciones: informe.anotaciones || '',
            sin_firma: informe.sin_firma || false,
          };

          // Generar PDF como blob SIN imágenes para envío por WhatsApp
          const pdfResult = await generateActaVisitaPDFBlobWithoutImages(actaData, caso, caso.informes_adicionales || []);

          if (pdfResult.success) {
            // Crear archivo con nombre específico
            const fileName = `Acta_Visita_${caso.numero_reclamo || 'documento'}_${new Date().toISOString().split('T')[0]}.pdf`;
            const pdfFile = new File([pdfResult.blob], fileName, { type: 'application/pdf' });
            formData.append('pdf_file', pdfFile);
            // Generar PDF adicional CON imágenes (evidencias) y adjuntarlo
            const evidenciasResult = await generateActaVisitaPDFBlob(actaData, caso, caso.informes_adicionales || []);
            if (evidenciasResult.success) {
              const evidenciasFileName = `Acta_Visita_Evidencias_${caso.numero_reclamo || 'documento'}_${new Date().toISOString().split('T')[0]}.pdf`;
              const evidenciasFile = new File([evidenciasResult.blob], evidenciasFileName, { type: 'application/pdf' });
              formData.append('informe_pdf_evidencias', evidenciasFile);
            } else {
              console.error('Error generando PDF con evidencias:', evidenciasResult.error);
            }
          } else {
            throw new Error('Error generando PDF: ' + pdfResult.error);
          }
        }

        // Generar PDFs individuales para actas adicionales
        if (caso.informes_adicionales && caso.informes_adicionales.length > 0) {
          for (const adicional of caso.informes_adicionales) {
            // Mapear datos del acta adicional
            const actaAdicionalData = {
              // Información básica
              fecha_visita: adicional.fecha_visita || caso.informe?.fecha_visita || new Date().toISOString().split('T')[0],
              hora_visita: adicional.hora_visita || caso.informe?.hora_visita || new Date().toTimeString().slice(0, 5),
              ciudad_visita: adicional.ciudad_visita || caso.informe?.ciudad_visita || 'Bogotá',
              dia_visita: adicional.dia_visita || caso.informe?.dia_visita || new Date().getDate().toString(),
              mes_visita: adicional.mes_visita || caso.informe?.mes_visita || new Date().toLocaleDateString('es-ES', { month: 'long' }),
              año_visita: adicional.año_visita || caso.informe?.año_visita || new Date().getFullYear().toString(),
              archivo_no: adicional.archivo_no || '',
              no_pqrs: adicional.no_de_pqrs || '',
              cuenta_suscriptor: adicional.cuenta_suscriptor || '',
              cuenta_energia: adicional.cuenta_energia || '',
              direccion: adicional.direccion || caso.cliente?.[0]?.address?.[0]?.address || '',
              nombre_cliente: adicional.nombre_cliente || caso.cliente?.[0]?.full_name || '',
              direccion_informe: adicional.direccion_informe || '',

              // Datos del predio
              direccion_predio: adicional.direccion_predio || '',
              estrato_predio: adicional.estrato_predio || '',
              localidad_predio: adicional.localidad_predio || '',
              actualizacion_nombre_suscriptor: adicional.actualizacion_nombre_suscriptor || '',

              // Tablas dinámicas
              unidades_residenciales_detalle: adicional.unidades_residenciales_detalle ?
                (typeof adicional.unidades_residenciales_detalle === 'string' ?
                  JSON.parse(adicional.unidades_residenciales_detalle) :
                  adicional.unidades_residenciales_detalle) : [],
              producto_nombre: adicional.producto_nombre || '',
              producto_detalle: adicional.producto_detalle ?
                (typeof adicional.producto_detalle === 'string' ?
                  JSON.parse(adicional.producto_detalle) :
                  adicional.producto_detalle) : [],
              unidades_no_residenciales_detalle: adicional.unidades_no_residenciales_detalle ?
                (typeof adicional.unidades_no_residenciales_detalle === 'string' ?
                  JSON.parse(adicional.unidades_no_residenciales_detalle) :
                  adicional.unidades_no_residenciales_detalle) : [],
              producto_unr: adicional.producto_unr || '',
              recipientes_detalle: adicional.recipientes_detalle ?
                (typeof adicional.recipientes_detalle === 'string' ?
                  JSON.parse(adicional.recipientes_detalle) :
                  adicional.recipientes_detalle) : [],

              // Características del predio
              abandonado: adicional.abandonado || false,
              suscriptor_inactivo: adicional.suscriptor_inactivo || false,
              demolido: adicional.demolido || false,
              en_construccion: adicional.en_construccion || false,
              en_remodelacion: adicional.en_remodelacion || false,
              inexistente: adicional.inexistente || false,
              inhabitable_o_en_ruinas: adicional.inhabitable_o_en_ruinas || false,
              lote: adicional.lote || false,
              minimas_condiciones: adicional.minimas_condiciones || false,
              programa_del_icbf: adicional.programa_del_icbf || false,
              descuento_puerta_a_puerta: adicional.descuento_puerta_a_puerta || false,
              se_cierra_pqr_como_no_atendido: adicional.se_cierra_pqr_como_no_atendido || false,
              areas_comunes: adicional.areas_comunes || false,
              predio_que_se_observa_vacio: adicional.predio_que_se_observa_vacio || false,
              predio_se_observa_ocupado: adicional.predio_se_observa_ocupado || false,
              cuenta_suscriptor_activo: adicional.cuenta_suscriptor_activo || false,
              causa_demolicion: adicional.causa_demolicion || "",
              suscriptor_activo_detalles: adicional.suscriptor_activo_detalles || "",

              // Tipos de residuos
              tipos_residuos: {
                escombros: adicional.escombros || false,
                especiales: adicional.especiales || false,
                para_reuso: adicional.para_relleno || false,
                para_escombrera: adicional.para_escombrera || false,
                enlonado: adicional.enlonado || false,
                a_granel: adicional.a_granel || false
              },
              tipo_recoleccion: adicional.tipo_recoleccion || '',
              valor_m3: adicional.valor_m3 || '',
              m3_gratis: adicional.m3_gratis || false,
              dos_m3_gratis: (adicional.dos_m3_gratis ?? adicional['2m3_gratis']) || false,
              cancelado: adicional.cancelado || false,

              // Observaciones y representantes
              observaciones: adicional.observaciones || '',
              representante_nombre: adicional.representante_nombre || caso.cliente?.[0]?.full_name || '',
              representante_cedula: adicional.representante_cedula || caso.cliente?.[0]?.documentNumber || '',
              representante_firma: adicional.representante_firma,
              representante_telefono_celular: adicional.representante_telefono_celular || '',
              ciudad_limpia_nombre: caso.contacto?.[0]?.full_name || caso.agente?.full_name || '',
              ciudad_limpia_codigo: adicional.ciudad_limpia_codigo || caso.contacto?.[0]?.codigo_visitador || caso.agente?.codigo_visitador || '',
              ciudad_limpia_firma: adicional.ciudad_limpia_firma,
              ciudad_limpia_telefono: adicional.ciudad_limpia_telefono || '',
              anotaciones: adicional.anotaciones || '',
              sin_firma: adicional.sin_firma || false,
              images: adicional.images || [],
            };

            // Preparar datos del caso modificados para incluir las imágenes del acta adicional
            const casoParaPDFAdicional = {
              ...caso,
              informe: {
                ...(caso.informe || {}),
                images: adicional.images || []
              }
            };

            // Generar PDF para esta acta adicional usando la función especializada
            const pdfAdicionalResult = await generateActaAdicionalIndividualPDFBlob(actaAdicionalData, casoParaPDFAdicional);

            if (pdfAdicionalResult.success) {
              const fileNameAdicional = `Acta_Adicional_${adicional.id}_${caso.numero_reclamo || 'documento'}.pdf`;
              const pdfFileAdicional = new File([pdfAdicionalResult.blob], fileNameAdicional, { type: 'application/pdf' });
              formData.append(`informe_pdf_adicional_${adicional.id}`, pdfFileAdicional);
            } else {
              console.error(`Error generando PDF para acta adicional ${adicional.id}:`, pdfAdicionalResult.error);
            }
          }
        }

        const response = await postFinalizarCaso(id, formData);

        console.log("Respuesta del backend:", response);

        if (response.status === 200 || response.status === 206) {
          const successMessage = confirmed.withReport
            ? "El caso ha sido finalizado exitosamente con informe"
            : "El caso ha sido finalizado exitosamente sin enviar informe";

          Swal.fire({
            title: "OT Finalizada!",
            text: successMessage,
            icon: "success",
            confirmButtonText: "Cerrar",
            confirmButtonColor: "#28a745",
          }).then(() => {
            getCasoData();
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Hubo un problema al finalizar el caso",
            icon: "error",
            confirmButtonText: "Cerrar",
            confirmButtonColor: "#dc3545"
          });
        }
      } catch (error) {
        console.error("Error al finalizar caso:", error);
        Swal.fire({
          title: "Error",
          text: "Hubo un problema al finalizar el caso",
          icon: "error",
          confirmButtonText: "Cerrar",
          confirmButtonColor: "#dc3545"
        });
      }
    }
  };

  const actionSuccess = async () => {
    setActionAlert(false); // Cerrar modal de confirmación

    // Mostrar loading
    Swal.fire({
      title: 'Procesando...',
      text: 'Actualizando estado del caso...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const response = await postCasosStatusChange(ticketId, {
        accion: action,
        observaciones: observaciones,
        coordenadas: coordenadas,
      });

      Swal.close(); // Cerrar loading

      if (response.status === 200) {
        setShowAlertSuccess(true);
      } else {
        setErrorAlert(true);
      }
    } catch (error) {
      console.error("Error confirming action:", error);
      Swal.close();
      setErrorAlert(true);
    }
  };

  // Funciones para subida de imágenes
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    processFiles(files);
  };

  const handleImageUpload = async () => {
    if (selectedFiles.length === 0) return;

    setIsUploading(true);
    setUploadProgress(0);

    try {
      // Convertir archivos a base64
      const images = [];
      let processedFiles = 0;

      const processFiles = () => {
        return new Promise((resolve) => {
          selectedFiles.forEach((fileObj) => {
            const reader = new FileReader();
            reader.readAsDataURL(fileObj.file);
            reader.onload = function () {
              const base64 = reader.result;
              const base64Parts = base64.split(",");
              images.push({ image: base64Parts[1] });

              processedFiles++;

              // Actualizar progreso
              const progress = Math.floor((processedFiles / selectedFiles.length) * 90);
              setUploadProgress(progress);

              if (images.length === selectedFiles.length) {
                resolve();
              }
            };
          });
        });
      };

      await processFiles();

      // Preparar datos para actualizar solo la clave images
      const updateData = {
        images: images
      };

      // Usar patchCasosUpdate con los datos de imágenes en base64
      const response = await patchCasosUpdate({ id: id }, updateData);

      setUploadProgress(100);
      console.log(response);

      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          title: "¡Éxito!",
          text: `${selectedFiles.length} imagen(es) subida(s) correctamente`,
          icon: "success",
          confirmButtonText: "Cerrar",
          confirmButtonColor: "#28a745",
          timer: 3000,
          timerProgressBar: true
        });

        // Limpiar archivos seleccionados
        setSelectedFiles([]);
        // Limpiar el input file
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) fileInput.value = '';

        getCasoData(); // Refrescar para mostrar nuevas imágenes
      } else {
        throw new Error('Error en la respuesta del servidor');
      }
    } catch (error) {
      console.error('Error subiendo imágenes:', error);
      setUploadProgress(0);
      Swal.fire({
        title: "Error",
        text: "Hubo un problema al subir las imágenes",
        icon: "error",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#dc3545"
      });
    } finally {
      setIsUploading(false);
    }
  };

  // Función para formatear la dirección
  const formatAddress = (address) => {
    if (!address) return "No especificada";

    // Si es un string, devolverlo directamente
    if (typeof address === 'string') return address;

    // Si es un objeto, construir la dirección
    if (typeof address === 'object') {
      const parts = [];

      if (address.address) parts.push(address.address);
      if (address.barrio) parts.push(`Barrio ${address.barrio}`);
      if (address.localidad) parts.push(address.localidad);
      if (address.city) parts.push(address.city);
      if (address.state) parts.push(address.state);
      if (address.country) parts.push(address.country);

      return parts.length > 0 ? parts.join(', ') : "No especificada";
    }

    return "No especificada";
  };
  useEffect(() => {
    if (id) {
      getCasoData();
      getAgentData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Helper for Status Badge
  function StatusGlow({ estado }) {
    const statusMap = {
      'ASIGNADO': 'status-glow-asignado',
      'PENDIENTE': 'status-glow-pendiente',
      'EN_PROCESO': 'status-glow-proceso',
      'FINALIZADO': 'status-glow-final',
      'EN_PAUSA': 'status-glow-pausa',
      'SIN_ASIGNAR': 'status-glow-default',
      'EN_AFORO': 'status-glow-aforo'
    };

    const className = statusMap[estado] || 'status-glow-default';
    const label = estado ? estado.replace(/_/g, ' ') : 'S/E';
    const iconMap = {
      'ASIGNADO': 'fas fa-user-check',
      'PENDIENTE': 'fas fa-clock',
      'EN_PROCESO': 'fas fa-spinner fa-spin',
      'FINALIZADO': 'fas fa-check-circle',
      'EN_PAUSA': 'fas fa-pause-circle',
      'SIN_ASIGNAR': 'fas fa-exclamation-circle',
      'EN_AFORO': 'fas fa-balance-scale'
    };
    const icon = iconMap[estado] || 'fas fa-circle';

    return (
      <span className={`vb-status-badge ${className}`}>
        <i className={icon}></i>
        {label}
      </span>
    );
  }

  const fotos = caso.images;

  useEffect(() => {
    if (fotos && fotos.length > 0) {
      setImagenSeleccionada(fotos[0].image);
    }
  }, [fotos]);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const files = Array.from(e.dataTransfer.files).filter(file => file.type.startsWith('image/'));
    if (files.length > 0) processFiles(files);
  };

  const processFiles = (files) => {
    const filesWithPreviews = [];
    let processedCount = 0;
    files.forEach((file, index) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        filesWithPreviews[index] = {
          file: file,
          preview: e.target.result,
          name: file.name,
          size: file.size
        };
        processedCount++;
        if (processedCount === files.length) {
          setSelectedFiles(prev => [...prev, ...filesWithPreviews]);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Ciudad Limpia | Detalles del OT</title>
        </MetaTags>

        <Container fluid className="px-0">
          {props.loading ? (
            <Loader />
          ) : (
            <div className="case-details-vibrant" data-theme={theme}>

              {/* === HERO CARD === */}
              <div className="vibrant-header-card">
                <div className="vb-header-top">
                  <div className="d-flex flex-column gap-3 flex-grow-1">
                    <div className="d-flex align-items-center gap-3">
                      <ButtonVolver />
                      <div className="vb-case-meta">
                        <span className="vb-id-badge">OT #{caso.id}</span>
                        {caso.tipo_orden && <span className="vb-id-badge" style={{ background: 'var(--vb-surface-hover)' }}>{caso.tipo_orden}</span>}
                        {caso.estado && <StatusGlow estado={caso.estado} />}
                      </div>
                    </div>

                    <div className="vb-title-group">
                      <h1>{caso.name ? caso.name.replace(/^Caso\s/, '') : 'Cargando Caso...'}</h1>
                    </div>
                  </div>

                  {/* Actions Toolbar */}
                  <div className="vb-actions">
                    {caso.estado !== "FINALIZADO" && (
                      <>
                        {(caso.estado === "ASIGNADO" || caso.estado === "SIN_ASIGNAR") && (
                          <button onClick={() => handleAction("ACEPTAR", caso.name, caso.id)} className="btn-vb btn-vb-success">
                            <i className="fas fa-check"></i>
                            <span>Aceptar</span>
                          </button>
                        )}
                        {caso.estado === "PENDIENTE" && (
                          <button onClick={() => handleAction("INICIAR", caso.name, caso.id)} className="btn-vb btn-vb-primary">
                            <i className="fas fa-play"></i>
                            <span>Iniciar</span>
                          </button>
                        )}
                        {caso.estado === "EN_PROCESO" && (
                          <>
                            <button onClick={() => handleAction("PAUSAR", caso.name, caso.id)} className="btn-vb btn-vb-warning">
                              <i className="fas fa-pause"></i>
                              <span>Pausar</span>
                            </button>
                            <button onClick={() => handleFinalizar(caso.name, caso.id)} className="btn-vb btn-vb-danger">
                              <i className="fas fa-stop"></i>
                              <span>Finalizar</span>
                            </button>
                          </>
                        )}
                        {caso.estado === "EN_PAUSA" && (
                          <button onClick={() => handleAction("REANUDAR", caso.name, caso.id)} className="btn-vb btn-vb-primary">
                            <i className="fas fa-play"></i>
                            <span>Reanudar</span>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>

                {/* Info Grid */}
                <div className="vb-info-grid">
                  <div className="vb-info-card">
                    <span className="vb-label">Solicitante</span>
                    <span className="vb-value">
                      <i className="fas fa-user"></i>
                      <span>{caso.cliente && caso.cliente.length > 0 ? (caso.cliente[0].full_name || caso.cliente[0].get_full_name) : 'No asignado'}</span>
                    </span>
                  </div>
                  <div className="vb-info-card">
                    <span className="vb-label">Ubicación</span>
                    <span className="vb-value" title={caso.cliente?.[0]?.address?.[0] ? formatAddress(caso.cliente?.[0]?.address?.[0]) : ''}>
                      <i className="fas fa-map-marker-alt"></i>
                      <span className="text-truncate" style={{ maxWidth: '200px' }}>
                        {formatAddress(caso.cliente?.[0]?.address?.[0])}
                      </span>
                    </span>
                  </div>
                  <div className="vb-info-card">
                    <span className="vb-label">Radicación</span>
                    <span className="vb-value">
                      <i className="far fa-calendar-alt"></i>
                      <span>{caso.created_date ? new Date(caso.created_date).toLocaleDateString() : 'N/A'}</span>
                    </span>
                  </div>
                  <div className="vb-info-card">
                    <span className="vb-label">Vencimiento</span>
                    <span className="vb-value">
                      <i className="far fa-clock"></i>
                      <div className="d-flex flex-column align-items-start" style={{ lineHeight: '1.2' }}>
                        <span>{caso.fecha_vencimiento || 'N/A'}</span>
                        {caso.fecha_vencimiento && (() => {
                          const d = new Date(caso.fecha_vencimiento).toISOString().slice(0, 10);
                          const today = new Date().toISOString().slice(0, 10);
                          if (d < today && caso.estado !== "FINALIZADO") {
                            return <span className="vb-badge-alert badge-danger-glow mt-1">VENCIDO</span>;
                          }
                          const diffDays = Math.ceil((new Date(d) - new Date(today)) / (1000 * 60 * 60 * 24));
                          if (diffDays >= 0 && diffDays <= 2 && caso.estado !== "FINALIZADO") {
                            return <span className="vb-badge-alert badge-warning-glow mt-1">PRÓXIMO A VENCER</span>;
                          }
                          return null;
                        })()
                        }
                      </div>
                    </span>
                  </div>
                </div>
              </div>

              {/* === TABS SECTION === */}
              <div className="vb-tabs-wrapper">
                <Nav tabs className="mb-4">
                  {[
                    { id: '1', icon: 'fas fa-info-circle', label: 'Detalles Generales' },
                    { id: '2', icon: 'fas fa-city', label: 'Catastro Ciudad Limpia' },
                    { id: '3', icon: 'fas fa-bolt', label: 'Catastro Enel' },
                    { id: '4', icon: 'fas fa-tasks', label: 'Gestiones y Tareas' },
                    { id: '5', icon: 'fas fa-file-invoice-dollar', label: 'Datos Facturación' },
                    { id: 'acta', icon: 'fas fa-clipboard-check', label: 'Actas de Visita', action: true }
                  ].map(tab => (
                    <NavItem key={tab.id}>
                      <NavLink
                        className={`vb-tab-link ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={(e) => {
                          if (tab.action) {
                            e.preventDefault();
                            history.push(`/casos/${id}/acta-visita`);
                          } else {
                            toggle(tab.id);
                          }
                        }}
                      >
                        <i className={`${tab.icon} me-2`}></i>
                        <span>{tab.label}</span>
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>

                <div className="vb-content-body">
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      <DetallesOT caso={caso} fotos={fotos} url={url} />
                    </TabPane>
                    <TabPane tabId="2">
                      {caso.cliente && caso.cliente.length > 0
                        ? caso.cliente.map((c, i) => <CatastroCiudadLimpia key={i} cliente={c} />)
                        : <div className="vb-empty-state">
                          <i className="fas fa-search-location fa-3x mb-3"></i>
                          <h5>Sin Datos de Catastro</h5>
                          <p>No se encontró información de Ciudad Limpia para este cliente.</p>
                        </div>
                      }
                    </TabPane>
                    <TabPane tabId="3">
                      {caso.cliente && caso.cliente.length > 0
                        ? caso.cliente.map((c, i) => <CatastroEnel key={i} cliente={c} casoId={caso.id} />)
                        : <div className="vb-empty-state">
                          <i className="fas fa-bolt fa-3x mb-3"></i>
                          <h5>Sin Datos de Enel</h5>
                          <p>No se encontró información de Enel para este cliente.</p>
                        </div>
                      }
                    </TabPane>
                    <TabPane tabId="4">
                      {caso.gestiones && caso.gestiones.length > 0 ? (
                        <GestionesCaso gestiones={caso.gestiones} />
                      ) : (
                        <div className="vb-empty-state">
                          <i className="fas fa-tasks fa-3x mb-3"></i>
                          <h5>Sin Gestiones</h5>
                          <p>No hay gestiones registradas para este caso.</p>
                        </div>
                      )}
                    </TabPane>
                    <TabPane tabId="5">
                      <DatosFacturacion metadata={caso.metadata} />
                    </TabPane>
                  </TabContent>
                </div>
              </div>

            </div>
          )}
        </Container>

        {/* SweetAlerts */}
        {actionAlert && (
          <SweetAlert
            title={`¿${action} OT ${ticket} ?`}
            warning
            showConfirm={true}
            confirmBtnText="Confirmar"
            showCancel={true}
            cancelBtnBsStyle="light"
            cancelBtnText="Cancelar"
            confirmBtnBsStyle="success"
            onCancel={() => setActionAlert(false)}
            onConfirm={() => actionSuccess()}
            style={{ borderRadius: '16px' }}
          >
            <div className="mt-3 text-start">
              <Label className="fw-bold text-muted text-uppercase small">Observaciones Adicionales</Label>
              <Input
                type="textarea"
                id="observaciones"
                name="observaciones"
                rows="4"
                className="form-control"
                style={{ borderRadius: '12px', padding: '12px' }}
                onChange={(e) => setObservaciones(e.target.value)}
                placeholder="Ingrese cualquier detalle relevante sobre esta acción..."
              />
            </div>
          </SweetAlert>
        )}

        {showAlertSuccess && (
          <SweetAlert
            title="¡Acción Exitosa!"
            success
            showConfirm={false}
            timeout={2000}
            style={{ borderRadius: '16px' }}
            onConfirm={() => {
              getCasoData();
              setShowAlertSuccess(false);
            }}
          />
        )}

        {errorAlert && (
          <SweetAlert
            title="¡Error!"
            danger
            showConfirm={false}
            timeout={2000}
            style={{ borderRadius: '16px' }}
            onConfirm={() => {
              getCasoData();
              setErrorAlert(false);
            }}
          />
        )}

        <CasosCensoModal
          isOpen={showCensoModal}
          toggle={() => setShowCensoModal(false)}
          onSuccess={() => {
            setShowCensoModal(false);
            getCasoData();
          }}
        />

        {canReopenCase && isFinalizado && (
          <div style={{ position: 'fixed', bottom: '30px', right: '30px', zIndex: 1060 }}>
            <Button
              onClick={handleReabrirCaso}
              id="reopen-btn"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                padding: '16px 24px',
                borderRadius: '50px',
                background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
                color: '#fff',
                border: 'none',
                boxShadow: '0 10px 25px -5px rgba(234, 88, 12, 0.4)',
                fontWeight: 700,
                letterSpacing: '0.02em',
                fontSize: '1rem',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <IoRefreshCircleOutline style={{ fontSize: '24px' }} />
              Reabrir Caso
            </Button>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default CasosDetails;
